"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createURL;
/**
 * Creates a url from base and params
 * @param {string} url
 * @param {Object} [params] Query string params
 * @returns {string} url
 * @memberof module:@sm/utils
 */
function createURL(url, params) {
  if (!params || typeof params !== 'object' || Object.keys(params).length === 0) return url;
  var queryString = Object.keys(params).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
  }).join('&');
  var queryURL = "".concat(url, "?").concat(queryString);
  return queryURL;
}
module.exports = exports.default;
//# sourceMappingURL=createURL.js.map